import { isUserLoggedIn } from 'redux/modules/sessions/selectors';

import urls from 'constants/urls';

const loggedInRoutes = [
  { path: urls.bookslot },
  { path: urls.boughtInStore },
  { path: urls.favourites },
  { path: urls.interstitials },
  { path: urls.lists },
  { path: urls.myAccount },
  { path: urls.myDetailsPage },
  { path: urls.moreOfWhatYouLove },
  { path: urls.orderReplacementCard },
  { path: urls.quickShop },
  { path: urls.shopFromPreviousInterstitial },
  { path: urls.shopByList },
  { path: '/ecom/shopping-lists' },
  { path: urls.trolleyPage },
];

const publicRouteExceptions = [{ path: urls.shopByListUpload }];

const pathInRouteList = (routeList = [], pathname = '') =>
  routeList.filter(({ path }) => pathname.startsWith(path));

export const isAuthorised = ({ location: { pathname }, store: { getState } }) => {
  if (isUserLoggedIn(getState())) {
    return true;
  }

  const matchingPublicRouteExceptions = pathInRouteList(publicRouteExceptions, pathname);

  if (matchingPublicRouteExceptions.length) {
    return true;
  }

  const matchingLoggedInRoutes = pathInRouteList(loggedInRoutes, pathname);

  return matchingLoggedInRoutes.length === 0;
};
